import { render, staticRenderFns } from "./ClimbingSession.vue?vue&type=template&id=59aec3ba"
import script from "./ClimbingSession.vue?vue&type=script&lang=js"
export * from "./ClimbingSession.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports